export enum ItemType {
  PRODUCT = 'PRODUCT', // Tangible physical goods (e.g., Fuel, Lubes, Snacks)
  SERVICE = 'SERVICE', // Intangible (e.g., Car Wash, Labor)
  RAW_MATERIAL = 'RAW_MATERIAL' // For future manufacturing/packaging
}
